import React from 'react';

export default ({ color, width, height }) => (
  <svg version="1.1" id="Layer_1" width={width} height={height} viewBox="0 0 58 64">
    <g id="Page-1">
      <g id="Alarm-System">
        <path
          id="Shape"
          style={{ fill: color }}
          d="M38.7,0.2c-0.1-0.1-0.2-0.1-0.3-0.2S38.2,0,38.1,0H0.8C0.7,0,0.6,0,0.5,0.1
			c-0.1,0-0.2,0.1-0.3,0.2S0.1,0.4,0.1,0.5S0,0.7,0,0.8v62.1c0,0.1,0,0.2,0.1,0.3c0,0.1,0.1,0.2,0.2,0.3c0.1,0.1,0.2,0.1,0.3,0.2
			c0.1,0,0.2,0.1,0.3,0h37.2c0.1,0,0.2,0,0.3,0c0.1,0,0.2-0.1,0.3-0.2c0.1-0.1,0.1-0.2,0.2-0.3c0-0.1,0.1-0.2,0.1-0.3V0.8
			C38.9,0.6,38.8,0.4,38.7,0.2z M37.4,62.2h-0.1v-0.1H1.6V1.6h35.6v60.4h0.1V62.2z"
        />
        <path id="Shape_1_" style={{ fill: color }} d="M37.2,62.1v0.1h0.1v-0.1H37.2z M37.2,62.1v0.1h0.1v-0.1H37.2z" />
        <path
          id="Shape_2_"
          style={{ fill: color }}
          d="M33.8,5.1C33.7,5,33.6,5,33.5,4.9c-0.1,0-0.2-0.1-0.3-0.1H5.6c-0.1,0-0.2,0-0.3,0.1
			C5.2,5,5.1,5,5.1,5.1C5,5.2,4.9,5.3,4.9,5.4c0,0.1-0.1,0.2-0.1,0.3v28.9c0,0.1,0,0.2,0.1,0.3c0,0.1,0.1,0.2,0.2,0.3
			c0.2,0.1,0.4,0.2,0.6,0.2h27.6c0.2,0,0.4-0.1,0.6-0.2c0.1-0.1,0.1-0.2,0.2-0.3c0-0.1,0.1-0.2,0.1-0.3v-29C34,5.4,34,5.2,33.8,5.1z
			 M32.4,33.8h-26V6.5H6.3V6.3h0.1v0.1h26V33.8z"
        />
        <path id="Shape_3_" style={{ fill: color }} d="M6.3,6.3v0.1h0.1V6.3H6.3z M6.3,6.3v0.1h0.1V6.3H6.3z" />
        <path
          id="Path"
          style={{ fill: color }}
          d="M34,39.4c0,0.1,0,0.2-0.1,0.3c0,0.1-0.1,0.2-0.2,0.3c-0.2,0.1-0.4,0.2-0.6,0.2H5.6
			c-0.2,0-0.4-0.1-0.6-0.2c-0.1-0.2-0.2-0.4-0.2-0.6c0-0.2,0.1-0.4,0.2-0.6c0.2-0.1,0.4-0.2,0.6-0.2h27.6c0.2,0,0.4,0.1,0.6,0.2
			c0.1,0.1,0.1,0.2,0.2,0.3C34,39.2,34.1,39.3,34,39.4z"
        />
        <path
          id="Shape_4_"
          style={{ fill: color }}
          d="M7.4,43.5c-0.5,0-1,0.1-1.4,0.4C5.5,44.2,5.2,44.6,5,45c-0.2,0.5-0.2,1-0.1,1.5
			s0.3,0.9,0.7,1.3c0.4,0.4,0.8,0.6,1.3,0.7c0.5,0.1,1,0,1.5-0.1c0.5-0.2,0.9-0.5,1.1-0.9C9.8,47,9.9,46.5,9.9,46
			c0-0.7-0.3-1.3-0.8-1.8C8.7,43.7,8,43.5,7.4,43.5z M8,46.6c-0.1,0.1-0.2,0.2-0.3,0.2c-0.1,0-0.2,0.1-0.3,0.1s-0.2,0-0.3-0.1
			c-0.1,0-0.2-0.1-0.3-0.2c-0.1-0.1-0.2-0.2-0.2-0.3c0-0.1-0.1-0.2-0.1-0.3c0-0.2,0.1-0.5,0.3-0.6c0.1-0.1,0.2-0.2,0.3-0.2
			c0.1,0,0.2-0.1,0.3-0.1s0.2,0,0.3,0.1c0.1,0,0.2,0.1,0.3,0.2c0.2,0.2,0.3,0.4,0.3,0.6C8.3,46.2,8.2,46.4,8,46.6L8,46.6z"
        />
        <path
          id="Shape_5_"
          style={{ fill: color }}
          d="M15.4,43.5c-0.5,0-1,0.1-1.4,0.4c-0.4,0.3-0.7,0.7-0.9,1.1c-0.2,0.5-0.2,1-0.1,1.5
			s0.3,0.9,0.7,1.3c0.4,0.4,0.8,0.6,1.3,0.7c0.5,0.1,1,0,1.5-0.1c0.5-0.2,0.9-0.5,1.1-0.9C17.8,47,18,46.5,18,46
			c0-0.7-0.3-1.3-0.8-1.8C16.7,43.7,16.1,43.5,15.4,43.5z M15.4,46.9c-0.1,0-0.2,0-0.3-0.1c-0.1,0-0.2-0.1-0.3-0.2
			c-0.1-0.1-0.2-0.2-0.2-0.3c0-0.1-0.1-0.2-0.1-0.3c0-0.2,0.1-0.5,0.3-0.6c0.1-0.1,0.2-0.2,0.3-0.2c0.1,0,0.2-0.1,0.3-0.1
			c0.1,0,0.2,0,0.3,0.1c0.1,0,0.2,0.1,0.3,0.2c0.2,0.2,0.3,0.4,0.3,0.6c0,0.1,0,0.2-0.1,0.3c0,0.1-0.1,0.2-0.2,0.3
			c-0.1,0.1-0.2,0.1-0.3,0.2C15.7,46.9,15.5,46.9,15.4,46.9L15.4,46.9z"
        />
        <path
          id="Shape_6_"
          style={{ fill: color }}
          d="M23.4,43.5c-0.5,0-1,0.1-1.4,0.4c-0.4,0.3-0.7,0.7-0.9,1.1c-0.2,0.5-0.2,1-0.1,1.5
			c0.1,0.5,0.3,0.9,0.7,1.3c0.4,0.4,0.8,0.6,1.3,0.7c0.5,0.1,1,0,1.5-0.1c0.5-0.2,0.9-0.5,1.1-0.9C25.8,47,26,46.5,26,46
			c0-0.3-0.1-0.7-0.2-1c-0.1-0.3-0.3-0.6-0.6-0.8c-0.2-0.2-0.5-0.4-0.8-0.5C24.1,43.5,23.8,43.5,23.4,43.5z M23.4,46.9
			c-0.2,0-0.5-0.1-0.6-0.3c-0.2-0.2-0.3-0.4-0.3-0.6c0-0.2,0.1-0.5,0.3-0.6c0.2-0.2,0.4-0.3,0.6-0.3c0.2,0,0.5,0.1,0.6,0.3
			c0.2,0.2,0.3,0.4,0.3,0.6c0,0.1,0,0.2-0.1,0.3s-0.1,0.2-0.2,0.3c-0.1,0.1-0.2,0.1-0.3,0.2C23.7,46.9,23.6,46.9,23.4,46.9
			L23.4,46.9z"
        />
        <path
          id="Shape_7_"
          style={{ fill: color }}
          d="M31.5,43.5c-0.5,0-1,0.1-1.4,0.4c-0.4,0.3-0.7,0.7-0.9,1.1c-0.2,0.5-0.2,1-0.1,1.5
			c0.1,0.5,0.3,0.9,0.7,1.3c0.4,0.4,0.8,0.6,1.3,0.7c0.5,0.1,1,0,1.5-0.1c0.5-0.2,0.9-0.5,1.1-0.9C33.9,47,34,46.5,34,46
			c0-0.7-0.3-1.3-0.8-1.8C32.8,43.7,32.2,43.5,31.5,43.5z M32.1,46.6c-0.1,0.1-0.2,0.2-0.3,0.2c-0.1,0-0.2,0.1-0.3,0.1
			c-0.2,0-0.5-0.1-0.6-0.3c-0.2-0.2-0.3-0.4-0.3-0.6c0-0.2,0.1-0.5,0.3-0.6s0.4-0.3,0.6-0.3c0.2,0,0.5,0.1,0.6,0.3s0.3,0.4,0.3,0.6
			c0,0.1,0,0.2-0.1,0.3C32.3,46.4,32.2,46.5,32.1,46.6L32.1,46.6z"
        />
        <path
          id="Path_1_"
          style={{ fill: color }}
          d="M46.9,19.8c0,0.9-0.2,1.8-0.5,2.6c-0.3,0.8-0.9,1.6-1.5,2.2c-0.2,0.2-0.4,0.2-0.6,0.3
			c-0.2,0-0.4-0.1-0.6-0.3c-0.1-0.1-0.1-0.2-0.2-0.3c0-0.1-0.1-0.2-0.1-0.3c0-0.1,0-0.2,0.1-0.3c0-0.1,0.1-0.2,0.2-0.3
			c0.9-0.9,1.4-2.2,1.4-3.5c0-1.3-0.5-2.6-1.4-3.5c-0.1-0.1-0.1-0.2-0.2-0.3c0-0.1-0.1-0.2-0.1-0.3c0-0.1,0-0.2,0.1-0.3
			c0-0.1,0.1-0.2,0.2-0.3c0.2-0.1,0.4-0.2,0.6-0.2c0.2,0,0.3,0,0.5,0.1h0.1C46.1,16.3,46.8,18,46.9,19.8z"
        />
        <path
          id="Path_2_"
          style={{ fill: color }}
          d="M52.4,19.8c0,1.4-0.3,2.8-0.8,4c-0.5,1.3-1.3,2.5-2.3,3.5c-0.2,0.2-0.4,0.2-0.6,0.2
			c-0.1,0-0.2,0-0.3-0.1c-0.1,0-0.2-0.1-0.3-0.2c-0.2-0.2-0.2-0.4-0.2-0.6v-0.1c0-0.2,0.1-0.4,0.2-0.6c1.7-1.7,2.6-4,2.6-6.4
			c0-1.2-0.2-2.3-0.7-3.4c-0.4-1.1-1.1-2.1-1.9-2.9c-0.2-0.1-0.2-0.4-0.2-0.6c0-0.2,0.1-0.3,0.2-0.4v-0.1c0.1-0.1,0.3-0.2,0.5-0.2
			c0.2,0,0.4,0.1,0.6,0.3C51.1,14.4,52.3,17,52.4,19.8z"
        />
        <polygon id="Path_3_" style={{ fill: color }} points="48,12.9 47.8,12.9 47.8,12.8 		" />
        <polygon id="Path_4_" style={{ fill: color }} points="48,12.3 48,12.3 48,12.3 		" />
        <polygon id="Path_5_" style={{ fill: color }} points="48.1,12.2 48.1,12.2 48.1,12.2 		" />
        <polygon id="Path_6_" style={{ fill: color }} points="48.2,12.2 48.1,12.2 48.1,12.2 48.1,12.3 48.1,12.1 		" />
        <path
          id="Path_7_"
          style={{ fill: color }}
          d="M57.8,19.8c0,1.9-0.4,3.8-1.1,5.6c-0.7,1.8-1.8,3.4-3.2,4.8c-0.1,0.1-0.2,0.1-0.3,0.2
			c-0.1,0-0.2,0.1-0.3,0.1c-0.1,0-0.2,0-0.3-0.1c-0.1,0-0.2-0.1-0.3-0.2c-0.1-0.1-0.1-0.2-0.2-0.3c0-0.1-0.1-0.2-0.1-0.3
			c0-0.1,0-0.2,0.1-0.3c0-0.1,0.1-0.2,0.2-0.3c1.2-1.2,2.2-2.6,2.8-4.2c0.7-1.6,1-3.2,1-4.9c0-1.7-0.3-3.4-1-5
			c-0.6-1.6-1.6-3-2.8-4.2c-0.1-0.1-0.1-0.2-0.2-0.3c0-0.1-0.1-0.2-0.1-0.3c0-0.2,0-0.3,0.1-0.5c0.1-0.1,0.2-0.3,0.4-0.3
			c0.2-0.1,0.3-0.1,0.5,0c0.2,0,0.3,0.1,0.4,0.2c1.3,1.4,2.4,3,3.1,4.7C57.5,16,57.9,17.9,57.8,19.8z"
        />
        <path
          id="Shape_8_"
          style={{ fill: color }}
          d="M30.2,10c-0.1-0.2-0.2-0.3-0.3-0.5c-0.2-0.1-0.3-0.2-0.5-0.2h-3c-0.1,0-0.2,0-0.3,0.1
			c-0.1,0-0.2,0.1-0.3,0.2l-8.8,8.8c-0.6-0.2-1.2-0.3-1.9-0.3c-1.7,0-3.3,0.7-4.5,1.8c-0.9,0.9-1.5,2-1.7,3.2
			c-0.2,1.2-0.1,2.5,0.4,3.6c0.5,1.2,1.3,2.1,2.3,2.8c1,0.7,2.3,1.1,3.5,1.1c1.7,0,3.3-0.7,4.5-1.8c0.6-0.6,1.1-1.3,1.4-2.1
			c0.3-0.8,0.5-1.6,0.5-2.4c0-0.6-0.1-1.3-0.3-1.9l2-2c0.1-0.1,0.2-0.2,0.2-0.4l0.4-2l1.9-0.4c0.2,0,0.3-0.1,0.4-0.2
			c0.1-0.1,0.2-0.3,0.2-0.4l0.4-1.9l1.9-0.4c0.1,0,0.2,0,0.3-0.1c0.1,0,0.1-0.1,0.2-0.2l0.9-0.9c0.2-0.2,0.2-0.4,0.2-0.6L30.2,10z
			 M28,13.5l-2.2,0.4c-0.2,0-0.3,0.1-0.4,0.2c-0.1,0.1-0.2,0.3-0.2,0.4l-0.4,1.9l-1.9,0.3c-0.2,0-0.3,0.1-0.4,0.2
			c-0.1,0.1-0.2,0.3-0.2,0.4l-0.4,2.2l-2.2,2.3c-0.1,0.1-0.1,0.2-0.2,0.3c0,0.1-0.1,0.2-0.1,0.3c0,0.1,0,0.2,0.1,0.3
			c0.2,0.6,0.4,1.2,0.4,1.8c0,0.9-0.3,1.8-0.8,2.6s-1.3,1.3-2.1,1.7c-0.9,0.3-1.8,0.4-2.7,0.2c-0.9-0.2-1.7-0.6-2.4-1.3
			c-0.6-0.7-1.1-1.5-1.3-2.4c-0.2-0.9-0.1-1.8,0.3-2.7c0.3-0.9,0.9-1.6,1.7-2.1c0.8-0.5,1.7-0.8,2.6-0.8c0.6,0,1.2,0.1,1.8,0.3
			c0.1,0.1,0.2,0.1,0.3,0.1c0.1,0,0.2,0,0.3-0.1c0.1,0,0.2-0.1,0.3-0.2l9-9h1.8l0.1,1.9L28,13.5z"
        />
        <polygon id="Path_8_" style={{ fill: color }} points="15.5,26.9 15.6,27 15.6,27 		" />
        <path
          id="Shape_9_"
          style={{ fill: color }}
          d="M16.3,25.5c0-0.3-0.1-0.6-0.2-0.8c-0.1-0.3-0.3-0.5-0.5-0.7c-0.4-0.4-1-0.6-1.6-0.6
			c-0.3,0-0.5,0.1-0.8,0.2s-0.5,0.3-0.7,0.5c-0.2,0.2-0.4,0.4-0.5,0.7c-0.1,0.3-0.2,0.6-0.2,0.8c0,0.3,0.1,0.6,0.2,0.8
			c0.1,0.3,0.3,0.5,0.5,0.7c0.2,0.2,0.4,0.4,0.7,0.5c0.3,0.1,0.5,0.2,0.8,0.2c0.3,0,0.6,0,0.8-0.2c0.3-0.1,0.5-0.3,0.7-0.5l-0.1-0.1
			l0.1,0.1c0.2-0.2,0.4-0.4,0.5-0.7C16.2,26.1,16.3,25.8,16.3,25.5z M14.6,25.5c0,0.1,0,0.1,0,0.2c0,0.1-0.1,0.1-0.1,0.2
			C14.3,26,14.2,26,14.1,26c-0.1,0-0.3-0.1-0.4-0.2c-0.1-0.1-0.2-0.2-0.2-0.4c0-0.1,0-0.1,0-0.2c0-0.1,0.1-0.1,0.1-0.2
			c0.1-0.1,0.2-0.2,0.4-0.2c0.1,0,0.3,0.1,0.4,0.2c0.1,0.1,0.1,0.1,0.1,0.2C14.6,25.3,14.6,25.4,14.6,25.5L14.6,25.5z"
        />
      </g>
    </g>
  </svg>
);



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/experiences/resources/react-svg/AlarmSystem.js